<template>
<div style="" class="coll">
    <vue-headful :title="$route.params.name.split('_').join(' ') +' – '+$route.params.question.split('_').join(' ')" />

    <div v-if="loading == false">





        <div v-if="selected == false" class="selector">

            <h1 style="color:black; margin: 1em;">@{{$route.params.name.split('_').join(' ')}} – {{ $route.params.question.split('_').join(' ') }}?</h1>
            <div class="bg">
                <qr-code style="display: inline-block !important; margin-top: 74px; border: 4px solid white;" :size='200' color="#4604FF" :text="'http://happyzuri.ch/where/'+ $route.params.name +'/' + $route.params.question"></qr-code>

            </div>
            <p>

            </p>
            <br>
            <p class="awys">Share this tag to get reactions and opinions. <br>   <b>Or share this link: </b> <input type="text" name="" :value="'http://happyzuri.ch/where/'+ $route.params.name +'/' + $route.params.question"></p>
            <button @click="reaction()">
          😍
          </button>
            <button @click="reactionContent()">
          😊
        </button>
            <button @click="reactionSad()">
          😞
        </button>
            <button @click="reactionVerysad()">
        😭
      </button>


        </div>

        <div v-if="selected == true" class="mini">

            <h1 >@{{$route.params.name.split('_').join(' ')}} – {{ $route.params.question.split('_').join(' ') }}?</h1>

            <button @click="reaction()">
        😍
        </button>
            <button @click="reactionContent()">
        😊
      </button>
            <button @click="reactionSad()">
        😞
      </button>
            <button @click="reactionVerysad()">
      😭
    </button>

            <button class="" @click="selected = false">
  Share
</button>

        </div>



        <div v-if="emojis[0] != null" class="emojisviz">
            <div class="viz happ">
                <span class="">😍</span><br><span> {{emojis[0].happy}}</span>
            </div>
            <div class="viz conten">
                <span>😊</span><br><span> {{emojis[0].content}}</span>
            </div>
            <div class="viz sa">
                <span>😞</span><br><span> {{emojis[0].sad}}</span>
            </div>

            <div class="viz verysa">
                <span>😭</span><br><span> {{emojis[0].verysad}}</span>
            </div>
        </div>

        <!-- <ul class="emojiList">
            <li v-for="emoji in emojis[0]" :key="emoji.key">
                {{emoji}}
                <button @click="deleteemoji(emoji)">
          Remove
        </button>
            </li>
        </ul> -->

    </div>
    <div v-else>
        <small>loading</small>
    </div>
</div>
</template>

<script>
import {
    db
} from '../firebase';


export default {
    name: 'collection',
    data() {
        return {
            emojis: [],
            happy: Number,
            sad: Number,
            content: Number,
            verysad: Number,
            msg: 'Collection',
            selected: false,
            newLoad: false,
            loading: true,
            newTarget: 0
        }
    },
    firestore() {
        return {
            emojis: db.collection(this.$route.params.name + this.$route.params.question)


        }
    },
    created() {
        this.$firestore.emojis.get().then(() => {
            this.loading = false

        })
    },
    mounted() {

    },
    methods: {

        addemoji: function() {
            this.$firestore.emojis.add({
                happy: 0,
                sad: 0,
                content: 0,
                verysad: 0,
                timestamp: new Date()
            });

        },
        deleteemoji: function(emoji) {
            this.$firestore.emojis.doc(emoji['.key']).delete();
        },
        reaction: function() {

            if (this.emojis.length == 0) {
                this.addemoji()

            }
            this.$firestore.emojis.doc(this.emojis[0]['.key']).update({
                happy: this.emojis[0]['happy'] + 1,

            })
            this.happy = this.emojis[0]['happy'] + 1;
            this.selected = true
        },

        reactionSad: function() {

            if (this.emojis.length == 0) {
                this.addemoji()
            }
            this.$firestore.emojis.doc(this.emojis[0]['.key']).update({
                sad: this.emojis[0]['sad'] + 1,

            })
            this.sad =this.emojis[0]['sad'] + 1;
            this.selected = true
        },
        reactionContent: function() {

            if (this.emojis.length == 0) {
                this.addemoji()
            }
            this.$firestore.emojis.doc(this.emojis[0]['.key']).update({
                content: this.emojis[0]['content'] + 1,

            })
            this.content =this.emojis[0]['content'] + 1;
            this.selected = true
        },
        reactionVerysad: function() {

            if (this.emojis.length == 0) {
                this.addemoji()
            }
            this.$firestore.emojis.doc(this.emojis[0]['.key']).update({
                verysad: this.emojis[0]['verysad'] + 1,

            })
            this.verysad=this.emojis[0]['verysad'] + 1;
            this.selected = true
        },
        updateEmotion: function() {
            // this.$firestore.this.emojis.doc(this.emoji['.key']).update({
            //     happy: this.happy + 1
            // })
        },
        animateHappy:function(){

        }
    },
    computed: {

    },
    watch: {
        happy: function() {
          this.$anime.timeline({
              })
              .add({
                  targets: '.happ',
                  scale: [1, 2.0],
                  easing: "easeOutQuint",
                  duration: 400,
              }).add({
                  targets: '.happ',
                  scale: [2.0, 1],
                  easing: "easeOutQuint",
                  duration: 400,
              });
        },

        sad: function() {
          this.$anime.timeline({
              })
              .add({
                  targets: '.sa',
                  scale: [1, 2.0],
                  easing: "easeOutQuint",
                  duration: 400,
              }).add({
                  targets: '.sa',
                  scale: [2.0, 1],
                  easing: "easeOutQuint",
                  duration: 400,
              });
        },
        content: function() {
          this.$anime.timeline({
              })
              .add({
                  targets: '.conten',
                  scale: [1, 2.0],
                  easing: "easeOutQuint",
                  duration: 400,
              }).add({
                  targets: '.conten',
                  scale: [2.0, 1],
                  easing: "easeOutQuint",
                  duration: 400,
              });
        },
        verysad: function() {
          this.$anime.timeline({
              })
              .add({
                  targets: '.verysa',
                  scale: [1, 2.0],
                  easing: "easeOutQuint",
                  duration: 400,
              }).add({
                  targets: '.verysa',
                  scale: [2.0, 1],
                  easing: "easeOutQuint",
                  duration: 400,
              });
        },



        // newTarget: debounce(function(){
        //   this.loading = false;
        // }, 1000),
        // loading: function(value) {
        //   if(!value){
        //     alert("done loading!")
        //   }
        // },
        emojis: function() {

            if (this.emojis != null) {
              this.sad =this.emojis[0]['sad']
              this.happy =this.emojis[0]['happy']
              this.content =this.emojis[0]['content']
              this.verysad =this.emojis[0]['verysad']
            }

        }
    }
}
</script>

<style>
.coll{
  color:black;
  overflow:hidden;
}
.viz {
    width: 20vw;
    font-size: 6vh;
    color: white;
    font-weight: 800;
}

.emojisviz {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
    width: 100vw;
}

.bg {
    /* background-image: url("../assets/bg_tag.svg"); */
    background-color: #FF4166;

    width: 322px;
    height: 348px;
    display: inline-block;
}

.selector {
    background: white;
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
      background: white;
    z-index: 10;
    left: 0;
}

.mini {
    background: white;
    padding-bottom: 2em;
    position: fixed;
    width: 100vw;
    bottom: 0;
    left: 0;


}
@media print {
  .coll{
    height: auto;
    width: 400px;
  }
  /* #logo{
    visibility: hidden;
  } */
  .awys{
    visibility: hidden;
  }
  .nav{
    visibility: hidden;
  }
  h1{
    font-size: 24px;
  }
  .selector{
    position: absolute;
      width:800px;

  }
  .emojisviz{
    visibility: hidden;
  }
}

@media (max-width: 764px) {
  .selector{
    position: absolute;
    min-height: 100vh;
    top:0;
    z-index:111;
    left:0;

  }
  .coll{
    padding-top: 2em;
    overflow-x: hidden;
    overflow-y: visible;
  }
  h1{

  }
  .emojisviz{
    position: fixed;
    height: 60vh;
    top:0;
  }
}
</style>
